module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("22Zgj"))).then(() => parcelRequire('5erN3'));